export default "__VITE_ASSET__CPh$9iMv__"